module.exports = __webpack_public_path__ + "background8.jpg?d4f00414d07f574f4cd310c05330cbf9";